import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';

//Services
import { getAllDetailsDirect, postAllData } from '../../../service/ProductService';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { convertSingleYear, convertYearforAccouting } from '../../../appconfig/AppHelper';
import { GETACCOUNTS, GETVOUCHERS, SAVEBANKENTRY } from '../../../config/ApiConstant';
import { accBankTypes, convertDateFrom, DWLIST } from '../../../appconfig/Settings';
import { AddBankEntryValidate } from '../../../config/Validate';

export const AddBankEntry = () => {
    document.title = 'Bank Entry | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    //Loading/Page Loading
    const [bankEntryData, setBankEntryData] = useState<any>({
        cheqNo: 'NET BK'
    });
    const [date, setDate] = useState<any>(new Date());
    const [voucher, setVoucher] = useState<any>(null);
    const [accounts, setAccounts] = useState<any>([]);
    const [errors, setErrors] = useState<any>({});
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        // Get Accouting Year
        let year = convertSingleYear(date);
        getVoucher(year);
        getAllAccounts();
    }, []);

    // Get voucher
    const getVoucher = async (year: any) => {
        try {
            const response = await getAllDetailsDirect(GETVOUCHERS + '?year=' + year);
            if (response) {
                setVoucher(response.bank_ref);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all accounts
    const getAllAccounts = async () => {
        try {
            const response = await getAllDetailsDirect(GETACCOUNTS);
            if (response) {
                let accOption: any = [];
                response.List.map((option: any) => {
                    accOption.push({ name: option.AccName, code: option.SrNo });
                });
                setAccounts(accOption);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'accName' || name === 'bankSelect' || name === 'dw') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setBankEntryData({ ...bankEntryData, [name]: val });
    };

    // handle change date
    const handleChangeDate = (val: any) => {
        setDate(val);
        let year = convertSingleYear(new Date(val));
        getVoucher(year);
    };

    // On submit
    const onSubmit = async () => {
        try {
            const { errors, isError } = AddBankEntryValidate(bankEntryData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoading(true);

                let formData: any = new FormData();
                formData.append('AccSrNo', Number(bankEntryData.bankSelect.code));
                formData.append('CusSrno', Number(bankEntryData.accName.code));
                formData.append('CqNo', bankEntryData.cheqNo);
                formData.append('amount', Number(bankEntryData.amount));
                formData.append('OthMsg', bankEntryData.dw.code);
                formData.append('Message', bankEntryData.remark);
                formData.append('Prefix', convertYearforAccouting(convertDateFrom(date)));
                formData.append('CurrDate', convertDateFrom(date));
                formData.append('RefNo', voucher);

                const response = await postAllData(SAVEBANKENTRY, formData);
                if (response) {
                    setSubmitLoading(false);
                    getVoucher(convertSingleYear(date));

                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                    setBankEntryData({
                        ...bankEntryData,
                        remark: '',
                        dw: null,
                        amount: '',
                        accName: null,
                        cheqNo: 'NET BK'
                    });
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setSubmitLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Account'} pageName={'Add Bank Entry'} pageTitle={'Add Bank Entry'} />

            <div className="card">
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-12">
                        {!window.cn(voucher) ? (
                            <>
                                <Tag className="mb-2" severity="info" value={'Voucher : ' + voucher}></Tag>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="bankSelect">
                            Select Bank <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={bankEntryData?.bankSelect}
                                name="bankSelect"
                                options={accBankTypes}
                                filter
                                optionLabel="name"
                                placeholder="Select Bank"
                                onChange={(e) => onInputChange(e.value, 'bankSelect')}
                                className={errors['bankSelect'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['bankSelect']}</small>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="date">
                            Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Calendar
                                value={date}
                                dateFormat="dd-M-yy"
                                onChange={(e: any) => {
                                    handleChangeDate(e.value);
                                }}
                                showIcon
                            />
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="accName">
                            Acc Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={bankEntryData?.accName}
                                name="accName"
                                options={accounts}
                                filter
                                optionLabel="name"
                                placeholder="Select Account"
                                onChange={(e) => onInputChange(e.value, 'accName')}
                                className={errors['accName'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['accName']}</small>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="cheqNo">
                            Cheque No <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText value={bankEntryData?.cheqNo} name="cheqNo" autoComplete="off" placeholder="Enter Cheque No." onChange={(e) => onInputChange(e, 'cheqNo')} className={errors['cheqNo'] && 'p-invalid'} />
                        </div>
                        <small className="p-invalid-txt">{errors['cheqNo']}</small>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="dw">
                            D/W <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown value={bankEntryData?.dw} name="dw" options={DWLIST} filter optionLabel="name" placeholder="Select D/W" onChange={(e) => onInputChange(e.value, 'dw')} className={errors['dw'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['dw']}</small>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="amount">
                            Amount <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputNumber value={bankEntryData?.amount} name="amount" useGrouping={false} placeholder="Enter Amount" onChange={(e) => onInputChange(e, 'amount')} className={errors['amount'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['amount']}</small>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="remark">
                            Remark <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputTextarea rows={5} cols={30} value={bankEntryData?.remark} onChange={(e) => onInputChange(e, 'remark')} autoComplete="off" id="Address" />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['remark']}</small>
                    </div>
                </div>

                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button label="Submit" icon="pi pi-check" onClick={() => onSubmit()} loading={submitLoading} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
